import { CSSProperties, ReactNode } from 'react';
import { Box } from '@/components/Box/Box';
import { useTableSorting } from './hooks/useTableSorting';
import { TableSortNew } from './TableSortNew';
import { TableHeadCellWrapper } from './styles';

export type TextAlignType = CSSProperties['textAlign'];

type TableHeadCellNewType = {
  name?: string;
  hasSort?: boolean;
  width?: string;
  textAlign?: TextAlignType;
  children?: ReactNode;
};

export const TableHeadCellNew = ({ width, name, hasSort, textAlign = 'left', children }: TableHeadCellNewType) => {
  const { changeSorting, isAscendingSorting, isDescendingSorting, isUnsorted } = useTableSorting(name, hasSort);

  const sortTableData = () => {
    if (!hasSort) return;

    changeSorting();
  };

  return (
    <TableHeadCellWrapper hasSort={hasSort} width={width} onClick={sortTableData} textAlign={textAlign}>
      <Box display='inline-flex' alignItems='center' gap={'4px'}>
        {children}
        {hasSort && (
          <TableSortNew
            isAscendingSorting={isAscendingSorting}
            isDescendingSorting={isDescendingSorting}
            isUnsorted={isUnsorted}
          />
        )}
      </Box>
    </TableHeadCellWrapper>
  );
};
